import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootStoreType } from 'src/types/store';

let localPermissions: string[] = [];

const checkHavePermision = (arrKeys: string[], permissions: string[] | undefined): boolean => {
    return !arrKeys.find((key) => !permissions?.includes(key));
};

export const useCheckPermission = (keys: string | string[]) => {
    const permissions = useSelector((state: RootStoreType) => state.user.data?.permissions);
    const arrKeys: string[] = Array.isArray(keys) ? keys : [keys];

    const [havePermission, setHavePermission] = useState<boolean>(checkHavePermision(arrKeys, permissions));

    useEffect(() => {
        setHavePermission(checkHavePermision(arrKeys, permissions));
    }, [permissions]);

    if (permissions && !localPermissions.length) {
        localPermissions = permissions;
    }

    return havePermission;
};

export const checkPermission = (permission: string): boolean => {
    return localPermissions.includes(permission);
};
